import "./ArticleCard.scss"
import  { Link } from "react-router-dom"
import { _baseImageUrl } from "../../service/constants"

const ArticleCard = ({article}) => {

    return (
        <Link to={`/blog/${article.link}`} className="article-link">
                <div className="article-card">
                        <img src={_baseImageUrl + article.image.path} alt={article.title} />

                        <div className="article-card__wrapper">
                    <h2> {article.title} </h2>
                    <p className="article-card-descr">
                          {article.shortDescr}
                    </p>
                    <div className="article-card__bottom">
                        <div className="article-card__category"> {article.category} </div>
                        <div className="article-card__date"> {article.createdAt}</div>
                    </div>
                        </div>
                </div>     
        </Link>
    )

}
export default ArticleCard